import FingerprintIcon from "@mui/icons-material/Fingerprint";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";

export const MenuItems = [
  {
    path: "/",
    text: "BIOGRAPHy",
    icon: FingerprintIcon,
  },
  {
    path: "/work",
    text: "WORK",
    icon: AccountTreeIcon,
  },
  // {
  //   path: "/performances",
  //   text: "PERFORMANCE",
  //   icon: PlayArrowIcon,
  // },
  // {
  //   path: "/library",
  //   text: "LIBRARY",
  //   icon: LibraryMusicIcon,
  // },
  {
    path: "/events",
    text: "EVENTS",
    icon: EmojiEventsIcon,
  },
  {
    path: "/contact",
    text: "CONTACT",
    icon: PermContactCalendarIcon,
  },
];
